/**
 * DevExtreme (ui/data_grid/ui.data_grid.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var DataGrid = require("./ui.data_grid.base");
module.exports = DataGrid;
require("./ui.data_grid.state_storing");
require("./ui.data_grid.selection");
require("./ui.data_grid.column_chooser");
require("./ui.data_grid.grouping");
require("./ui.data_grid.master_detail");
require("./ui.data_grid.editing");
require("./ui.data_grid.validating");
require("./ui.data_grid.virtual_scrolling");
require("./ui.data_grid.filter_row");
require("./ui.data_grid.header_filter");
require("./ui.data_grid.filter_sync");
require("./ui.data_grid.filter_builder");
require("./ui.data_grid.filter_panel");
require("./ui.data_grid.search");
require("./ui.data_grid.pager");
require("./ui.data_grid.columns_resizing_reordering");
require("./ui.data_grid.keyboard_navigation");
require("./ui.data_grid.summary");
require("./ui.data_grid.column_fixing");
require("./ui.data_grid.adaptivity");
require("./ui.data_grid.virtual_columns");
require("./ui.data_grid.export");
require("./ui.data_grid.focus");



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/data_grid/ui.data_grid.js
// module id = ../../../../devextreme/ui/data_grid/ui.data_grid.js
// module chunks = common